import React, { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import clx from 'classnames';
import { RANK_STEP_ACTIVE_RING_IMG } from '@/constants';
import { ProjectTime } from '@/types/home';
import { useStepList } from './hook';
import { useFm } from '@web3/base-hooks';

import styles from './stepListH5.module.scss';

const StepListH5 = ({ timeList }: { timeList: ProjectTime[] }) => {
  const { stepList, currentStep } = useStepList(timeList);
  const formatShortTime = (time: string) => {
    return dayjs(time).format('MM.DD HH:mm');
  };
  const fm = useFm();

  return (
    <div className={styles.stepList}>
      {stepList?.map((item, index) => (
        <div
          key={index}
          className={clx([
            styles.step,
            index === currentStep && [styles.active, 'active'],
          ])}
        >
          <div className={styles.label}>{item.label}</div>
          <div className={styles.time}>
            {index === 0
              ? `${fm('utcFeb28ToMar13')}`
              : `${fm('utcMar14ToMar27_2025')}`}
          </div>
          <div className={styles.status}>
            {index === currentStep ? (
              <img src={RANK_STEP_ACTIVE_RING_IMG} alt="ring" />
            ) : (
              <div className={styles.ring} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepListH5;
